<template>
  <div class="buscador-cliente-wrapper">
    <v-text-field
      v-model="inputSearch"
      label="Buscar por nombre, documento o teléfono..."
      prepend-inner-icon="mdi-magnify"
      outlined
      flat
      hide-details
      class="mb-4 search-bar-dark"
      autocomplete="off"
      clearable
      :loading="isLoading"
    ></v-text-field>

    <div v-if="isLoading" class="d-flex justify-center pa-10">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <v-expand-transition>
      <div v-if="clientes.length > 0 && !isLoading" class="resultados-grid">
        <h3 class="caption grey--text mb-2 ml-1 text-uppercase letter-spacing">Resultados encontrados</h3>
        <v-row dense>
          <v-col v-for="item in clientes" :key="item.id" cols="12" sm="6">
            <v-card 
              class="cliente-card-result clickable" 
              @click="seleccionarCliente(item)"
              outlined
            >
              <div class="d-flex align-center pa-3">
                <v-avatar color="primary darken-2" size="40" class="mr-3">
                  <span class="white--text font-weight-bold">{{ item.nombre.charAt(0) }}</span>
                </v-avatar>
                <div class="flex-grow-1 overflow-hidden">
                  <div class="white--text font-weight-bold text-truncate">{{ item.nombre }} {{ item.apellido }}</div>
                  <div class="caption grey--text text-truncate">{{ item.documento || 'Sin DNI' }}</div>
                </div>
                <v-icon color="primary" small>mdi-chevron-right</v-icon>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>

    <v-expand-transition>
      <div v-if="inputSearch && inputSearch.length >= 3 && clientes.length === 0 && !isLoading" class="mt-4">
        <v-card class="register-empty-state pa-6 text-center" outlined>
          <v-icon size="48" color="grey darken-1">mdi-account-search-outline</v-icon>
          <h3 class="white--text mt-3">¿No es cliente todavía?</h3>
          <p class="grey--text body-2">No encontramos a ningún "{{ inputSearch }}". ¡Regístralo ahora para que empiece a sumar puntos!</p>
          <v-btn 
            color="success" 
            class="mt-2 font-weight-black" 
            large
            rounded
            @click="$emit('click-agregar', inputSearch)"
          >
            <v-icon left>mdi-account-plus</v-icon>
            REGISTRAR NUEVO CLIENTE
          </v-btn>
        </v-card>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: "ClienteBuscador",
  props: {
    cliente: { type: [Object, null] },
  },
  data() {
    return {
      inputSearch: "",
      isLoading: false,
      clientes: [],
      timer: null
    };
  },
  methods: {
    seleccionarCliente(cliente) {
      this.$emit("set-cliente", cliente);
      this.inputSearch = "";
      this.clientes = [];
    },
    async buscarCliente(input) {
      if (!input || input.length < 2) {
        this.clientes = [];
        return;
      }
      try {
        this.isLoading = true;
        const q = input.trim().replace(/\s+/g, "-");
        const { data } = await this.axios.get(`/clientes/search?q=${q}`);
        this.clientes = data;
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    }
  },
  watch: {
    inputSearch(val) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => this.buscarCliente(val), 350);
    }
  }
};
</script>

<style lang="scss" scoped>
.search-bar-dark {
  ::v-deep .v-input__slot {
    background: rgba(255, 255, 255, 0.05) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
  }
}

.cliente-card-result {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  transition: all 0.2s;
  &:hover {
    background: rgba(33, 150, 243, 0.1) !important;
    border-color: #2196F3 !important;
    transform: translateY(-2px);
  }
}

.register-empty-state {
  background: rgba(76, 175, 80, 0.05) !important;
  border: 2px dashed rgba(76, 175, 80, 0.3) !important;
  border-radius: 16px !important;
}

.letter-spacing { letter-spacing: 1px; }
.clickable { cursor: pointer; }
</style>